var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v(_vm._s(this.$t('lang.search.empty_search_error')))]),_c('img',{staticClass:"align-middle",staticStyle:{"max-height":"300px"},attrs:{"src":require("../../assets/img/illustrations/alert-person.svg"),"width":"90%"}}),_c('p',[_vm._v(_vm._s(this.$t('lang.search.we_will_work')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }